import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase, Box } from '@mui/material';

// project imports
import config from 'config';
import Logo from '../../../assets/images/logos/finvetsa logo.svg';
import { MENU_OPEN } from 'store/actions';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase disableRipple onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })} component={Link} to={config.defaultPath}>
      {/* <Logo /> */}
      <Box
        component="img"
        sx={{ height: '10%',position:'fixed',marginLeft:'10rem' }}
        alt="Logo"
        src={Logo}
      />
    </ButtonBase>
  );
};

export default LogoSection;
